import { DASHBOARD_URLS, PAGE_URLS, ROLE_MAPPING } from '$constants';

export const getRedirectUrl = (user: any) => {
  if (user && user.roles && user.roles.length) {
    for (const role of user.roles) {
      const roleName = ROLE_MAPPING[role];
      switch (roleName) {
        case 'validation':
          return DASHBOARD_URLS.validation;
        case 'verification':
          return DASHBOARD_URLS.verification;
        case 'verificationQC':
          return DASHBOARD_URLS.verificationQC;
        case 'reportQC':
          return DASHBOARD_URLS.reportQC;
        case 'admin':
          return DASHBOARD_URLS.teamMembers;
        case 'fincancePaymentProcessing':
          return DASHBOARD_URLS.finance;
        case 'auditor':
          return DASHBOARD_URLS.auditDashboard;
        case 'applicantSupport':
          return DASHBOARD_URLS.applicantSupportDashboard;
        case 'accreditationCreator':
          return DASHBOARD_URLS.accreditationDatabase;
        case 'clientCreator':
          return DASHBOARD_URLS.clientDashboard;
        case 'iaAccreditor':
          return DASHBOARD_URLS.iaAccreditation;
        case 'iaAccreditorApprover':
          return DASHBOARD_URLS.iaAccreditaionApproval;
        case 'iaApprover':
          return DASHBOARD_URLS.iaApproval;
        case 'iaCreator':
          return DASHBOARD_URLS.iaCreation;
        case 'iaResearcher':
          return DASHBOARD_URLS.iaResearch;
        case 'insufficiencySupport':
          return DASHBOARD_URLS.insufficiencySupport;
        case 'partnerCreator':
          return DASHBOARD_URLS.partnerDashboard;
        case 'taskAllocator':
          return DASHBOARD_URLS.taskAllocation;
        case 'vendorCreator':
          return DASHBOARD_URLS.dashboardVendor;
        case 'vendorManagement':
          return DASHBOARD_URLS.dashboardVendor;
        case 'trackCases':
          return DASHBOARD_URLS.trackCases;
        case 'iaVendorMapping':
          return DASHBOARD_URLS.iaVendorMapping;
        case 'forceMajeure':
          return DASHBOARD_URLS.forceMajeure;
      }
    }
  }

  return PAGE_URLS.ssoLoginUrl;
};
